export const command = (commandName, data, resolver) => (dispatch) => {
    ((toDispatch) => new Promise((resolve) => {
        toDispatch({
            type: commandName,
            data: data
        });
        resolve();
    }))(dispatch).then(() => {
        if (resolver) {
            resolver();
        }
    });
};
